import React from 'react';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { ALL_EVENTS_GROUP } from '../../constants';

interface SelectSidebarProps {
  eventGroups: any[];
  setSelectedEventGroup: (group: any) => void;
  selectedEventGroup: any;
}

const SelectSidebar: React.FC<SelectSidebarProps> = ({ eventGroups, setSelectedEventGroup, selectedEventGroup }) => {
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const selectedGroup = JSON.parse(event.target.value);
    setSelectedEventGroup(selectedGroup);
  };

  return (
    <div className="basis-2/12 mb-5">
      <Select
        className="sidebar"
        value={selectedEventGroup ? JSON.stringify(selectedEventGroup) : ''}
        onChange={handleSelectChange}
        sx={{ width: '100%' }}
      >
        <MenuItem value="">Select Event Group</MenuItem>
        <MenuItem
          key={ALL_EVENTS_GROUP.id}
          value={JSON.stringify(ALL_EVENTS_GROUP)}
        >
          {ALL_EVENTS_GROUP.name}
        </MenuItem>
        {eventGroups.map((group: any) => (
          <MenuItem key={group.id} value={JSON.stringify(group)}>
            {group.name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default SelectSidebar;
